import { Autocomplete, AutocompleteItem, Checkbox, Input, Select, SelectItem, } from '@heroui/react';
import { DataGrid } from '@mui/x-data-grid';
import { ENUM_BILL_PAYMENT_TYPE, ENUM_BILL_TYPE_LIST,  ENUM_TRANSACTION_TYPE } from '../../constants/enum';
import { format } from "date-fns"
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Box } from '@mui/material';
import { faTemperatureEmpty } from '@fortawesome/free-solid-svg-icons';

const BillsDetail = ({ handleBillsDetail, billData, entryType, payCurrency }) => {

  const [isReadOnly, setIsReadOnly] = useState(true)
  //const [billData, setBillData] = useState([])

  // useEffect(() => {
  //   let data = bills

  //   if (payCurrency == '$') {
  //     data = bills.filter((ele) => ele.NetAmtD > 0)
  //     //console.log(bills,data)
  //   }
  //   setBillData(data)
  // }, [payCurrency, bills])

  const gridField = {
    billOf: "Bill_Of",
    acYear: "Ac_Year",
    billDate: "Bill_Date",
    dueDate: "DueDate",
    dueDays: "DueDays",
    diffDays: "Diff_Days",
    billNo: "Bill_No",
    oldInvNo: "OInv_No",
    billAmt: "NetAmt",
    billAmtD: "NetAmtD",
    tdsAmt: "ExtTDSAmt",
    balAmt: "BalAmt",
    balAmtMns: "BalAmt_Mns",
    balAmtD: "BalAmtD",
    balAmtMnsD: "BalAmtD_Mns",
    type: "Type",
    isSelected: "isSelected",
    recAmt: "NewPayAmt",
    recAmtD: "NewPayAmtD",
    convRate: "CRate"


  }
  const IsPayCurrencyDollar = () => {
    if (payCurrency && payCurrency != "" && payCurrency != null && payCurrency == "$")
      return true
    else
      return false
  }

  //console.log(data,"b")

  const handleSelectChange = (e, index) => {
    const { value } = e.target
    let newData = [...billData]

    if (value == ENUM_BILL_PAYMENT_TYPE.FULL) {
      setIsReadOnly(true)
      let amt = newData[index]["BalAmt"];
      if (newData[index]["DetailId"] > 0)
        amt = IsPayCurrencyDollar() ? newData[index]["BalNPayAmtD"] : newData[index]["BalNPayAmt"];
      else if (newData[index]["BalAmt"] <= 0)
        amt = IsPayCurrencyDollar() ? newData[index]["BalAmtD_Mns"] : newData[index]["BalAmt_Mns"]
      const NewPayColumn = IsPayCurrencyDollar() ? "NewPayAmtD" : "NewPayAmt"
      const updatedDataAmt = { ...billData[index], [NewPayColumn]: amt, Type: value };
      newData[index] = updatedDataAmt
      handleBillsDetail(newData)
    }
    else {
      setIsReadOnly(false)
      // if (newData[index]["DetailId"] > 0) {
      //   let amt = newData[index]["NewPayAmt"];
      //   const updatedRecAmt = { ...billData[index], NewPayAmt: 0, Type: value, BalAmt: amt };
      //   newData[index] = updatedRecAmt
      // }
      // else {
      const updatedRecAmt = { ...billData[index], NewPayAmt: 0, NewPayAmtD: 0, Type: value };
      newData[index] = updatedRecAmt
      //}
      handleBillsDetail(newData)
    }

  }
  const handleChange = (index, e) => {
    const { value } = e.target;
    const newData = [...billData]
    const NewPayColumn = IsPayCurrencyDollar() ? "NewPayAmtD" : "NewPayAmt"
    const updatedData = { ...billData[index], [NewPayColumn]: value }
    newData[index] = updatedData

    if ((IsPayCurrencyDollar && newData[index]["BalAmtD"] > 0 || (newData[index]["DetailId"] > 0) || newData[index]["BalAmtD_Mns"] > 0) || (newData[index]["BalAmt"] > 0 || (newData[index]["DetailId"] > 0) || newData[index]["BalAmt_Mns"] > 0)) {

      let balAmt = IsPayCurrencyDollar() ? newData[index]["BalAmtD"] : newData[index]["BalAmt"]
      const ColBalAmtMns = IsPayCurrencyDollar() ? "BalAmtD_Mns" : "BalAmt_Mns"
      const ColOldPayAmt = IsPayCurrencyDollar() ? "OldPayAmtD" : "OldPayAmt"
      const ColBalAmt = IsPayCurrencyDollar() ? "BalAmtD" : "BalAmt"
      if (newData[index][ColBalAmtMns] > 0) {
        balAmt = newData[index][ColBalAmtMns]
        if (newData[index]["DetailId"] > 0)
          balAmt = newData[index][ColBalAmtMns] + newData[index][ColOldPayAmt]
      }
      else {
        if (newData[index]["DetailId"] > 0)
          balAmt = newData[index][ColBalAmt] + newData[index][ColOldPayAmt]
      }

      if (value > balAmt) {
        newData[index][NewPayColumn] = 0
        toast.error("Receive Amount should be less than Balance Amount", {
          position: "top-center",
        })
      }
    }
    // else {
    //   let negativ_val = "-" + value
    //   let balAmt = newData[index]["BalAmt_Mns"]
    //   if (Number(negativ_val) < balAmt) {
    //     newData[index]["NewPayAmt"] = 0
    //     toast.error("Receive Amount should be less than Balance Amount", {
    //       position: "top-center"
    //     })
    //   }
    // }
    handleBillsDetail(newData)
  }



  const itemGridHeadClass = "bill-grid-style"
  const hanldeCheckChange = (index, e) => {
    const { checked } = e.target;


    if (IsPayCurrencyDollar()) {

      const newData = billData.map((row, i) => {
        let updatedRow = {
          ...row,
          IsSelected: false,

        };
        if (i === index && checked) {
          updatedRow = {
            ...row,
            IsSelected: true,
          };
        }

        return updatedRow;
      });

      handleBillsDetail(newData);

    }
    else {
      const newData = [...billData]
      let payType = ""
      let amt = 0;
      const NewPayColumn = IsPayCurrencyDollar() ? "NewPayAmtD" : "NewPayAmt"
      const BalColumn = IsPayCurrencyDollar() ? "BalAmtD" : "BalAmt"
      if (checked) {
        amt = IsPayCurrencyDollar() ? newData[index]["BalAmtD"] : newData[index]["BalAmt"];
        payType = ENUM_BILL_PAYMENT_TYPE.FULL
        if (newData[index]["DetailId"] > 0)
          amt = IsPayCurrencyDollar() ? newData[index]["BalNPayAmtD"] : newData[index]["BalNPayAmt"];
        else if (newData[index][BalColumn] <= 0)
          amt = IsPayCurrencyDollar() ? newData[index]["BalAmtD_Mns"] : newData[index]["BalAmt_Mns"]
      }
      const updatedData = { ...billData[index], IsSelected: checked, [NewPayColumn]: amt, Type: payType }
      newData[index] = updatedData
      handleBillsDetail(newData)
    }

  }
  const columns = [

    {
      field: gridField.id,
      headerName: "No.",
      width: 70,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div className=''>
          <Checkbox isSelected={row.IsSelected}
            color="primary"
            size="md"
            classNames={{
              label: "text-xs text-black font-bold",
            }}
            onChange={(e) => hanldeCheckChange(row.id - 1, e)} ></Checkbox>
          {row.id}
        </div>
      ),
    },
    {
      field: gridField.billOf,
      headerName: "Bill Of",
      width: 80,
      flex: 1,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.Bill_Of}
        </div>
      ),
    },
    {
      field: gridField.acYear,
      headerName: "Ac.Year",
      width: 50,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.Ac_Year}
        </div>
      ),
    },

    {
      field: gridField.billDate,
      headerName: "Bill Date",
      headerAlign: "center",
      flex: 1,
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.Bill_Date ? format(new Date(row.Bill_Date), "dd/MM/yyyy") : ""}
        </div>
      ),
    },
    {
      field: gridField.dueDate,
      headerName: "Due.Date",
      headerAlign: "center",
      flex: 1,
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.DueDate ? format(new Date(row.DueDate), "dd/MM/yyyy") : ""}
        </div>
      ),
    },
    {
      field: gridField.dueDays,
      headerName: "Due Days",
      width: 50,
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.DueDays}
        </div>
      ),
    },
    {
      field: gridField.diffDays,
      headerName: "Diff Days",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.Diff_Days}
        </div>
      ),
    },
    {
      field: gridField.billNo,
      headerName: "Bill No",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.Bill_No}
        </div>
      ),
    },
    {
      field: gridField.oldInvNo,
      headerName: "O.Inv.No",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.OInv_No}
        </div>
      ),
    },
    {
      field: gridField.billAmt,
      headerName: "Bill Amt.(Rs.)",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.NetAmt}
        </div>
      ),
    },
    {
      field: gridField.billAmtD,
      headerName: "Bill Amt.($)",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.NetAmtD}
        </div>
      ),
    },
    {
      field: gridField.tdsAmt,
      headerName: "Tds Amt.(Rs.)",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.ExtTDSAmt}
        </div>
      ),
    },
    {
      field: gridField.balAmt,
      headerName: "Bal Amt.(Rs.)",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.BalAmt}
        </div>
      ),
    },

    {
      field: gridField.balAmtMns,
      headerName: "(-)Bal Amt.(Rs.)",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.BalAmt_Mns}
        </div>
      ),
    },
    {
      field: gridField.convRate,
      headerName: "Conv Rate",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.CRate}
        </div>
      ),
    },
    {
      field: gridField.balAmtD,
      headerName: "Bal Amt.($)",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.BalAmtD}
        </div>
      ),
    },
    {
      field: gridField.balAmtMnsD,
      headerName: "(-)Bal Amt.($)",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <div>
          {row.BalAmtD_Mns}
        </div>
      ),
    },
    {
      field: gridField.type,
      headerName: "Type",
      headerAlign: "center",
      width: 120,
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (
        <Select name={"Type"}
          size="sm"
          variant='flat'
          placeholder='--select--'
          selectionMode='single'
          value={row.Type}
          className='w-full mt-1'
          color={"warning"}
          isVirtualized
          items={ENUM_BILL_TYPE_LIST ? ENUM_BILL_TYPE_LIST : []}
          onChange={(event) =>
            handleSelectChange(event, row.id - 1)
          }
          selectedKeys={[String(row.Type)]}
        >

          {(item) => {
            return (
              <SelectItem key={item.key}>
                {item.value}
              </SelectItem>
            )
          }}
        </Select>
      ),
    },
    // {
    //   field: gridField.oldRecAmt,
    //   headerName: "Old Rec Amt.(Rs.)",
    //   align: "center",
    //   headerClassName: itemGridHeadClass,
    //   renderCell: ({ row }) => (
    //     <div>
    //       {row.BalNPayAmt}
    //     </div>
    //   ),
    // },
    {
      field: gridField.recAmt,
      headerName: entryType == ENUM_TRANSACTION_TYPE.PAYMENT ? "Paid Amt.(Rs.)" : "Rec Amt.(Rs.)",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (

        <Input type="number" name={"NewPayAmt"}
          variant='flat'
          color="danger"
          // isReadOnly={row.Type == ENUM_BILL_TYPE.PART ? false : true}
          isReadOnly={row.Type == ENUM_BILL_PAYMENT_TYPE.PART ? false : isReadOnly}
          value={row.NewPayAmt}
          className='text-center  items-baseline mt-1'
          size="sm"
          onChange={(e) => handleChange(row.id - 1, e)} >
        </Input>

      ),
    },
    {
      field: gridField.recAmtD,
      headerName: entryType == ENUM_TRANSACTION_TYPE.PAYMENT ? "Paid Amt.($)" : "Rec Amt.($)",
      headerAlign: "center",
      headerClassName: itemGridHeadClass,
      renderCell: ({ row }) => (

        <Input type="number" name={"NewPayAmtD"}
          variant='flat'
          color="danger"
          // isReadOnly={row.Type == ENUM_BILL_TYPE.PART ? false : true}
          isReadOnly={row.Type == ENUM_BILL_PAYMENT_TYPE.PART ? false : isReadOnly}
          value={row.NewPayAmtD}
          className='text-center  items-baseline mt-1'
          size="sm"
          onChange={(e) => handleChange(row.id - 1, e)} >
        </Input>

      ),
    },

  ]

  return (
    <div className='bill_grid ' style={{ height: "350px", overflow: "scroll" }}>
      {/* // <Box sx={{ height: billData.length > 5 ? 0 : "auto", width: '100%' }}> */}
      {billData && billData?.length > 0 ? (
        <DataGrid
          rows={billData}
          columns={columns}
          editMode="row"
          headerClassName={"fix_head"}
          hideFooterPagination={billData && billData.length > 100 ? false : true}
          hideFooter={billData && billData.length > 100 ? false : true}
          columnHeaderHeight={35}
          sx={{
            '& .MuiDataGrid-columnHeaders': {
              position: 'sticky',
              top: 0,
              zIndex: 1, // Make sure the headers are above the rows when scrolling

            },
          }}
          rowHeight={41}
          //disableColumnResize={true}
          pageSizeOptions={[]}
          disableColumnSorting={true}
          disableColumnMenu={true}
          columnVisibilityModel={{
            [gridField.balAmtD]: IsPayCurrencyDollar(),
            [gridField.billAmtD]: IsPayCurrencyDollar(),
            [gridField.balAmtMnsD]: IsPayCurrencyDollar(),
            [gridField.recAmtD]: false,
            [gridField.convRate]: IsPayCurrencyDollar(),
            [gridField.type]: IsPayCurrencyDollar() ? false : true,
            [gridField.balAmt]: !IsPayCurrencyDollar(),
            [gridField.billAmt]: !IsPayCurrencyDollar(),
            [gridField.balAmtMns]: !IsPayCurrencyDollar(),
            [gridField.recAmt]: !IsPayCurrencyDollar(),
            [gridField.tdsAmt]: !IsPayCurrencyDollar(),
          }}

        />

      ) : (
        <h2>Bills Not Found</h2>
      )}

    </div>
  )

};

export default BillsDetail;
